import React, { useId, useState } from 'react';
import { Button } from '@dashboard/components/ui/button';
import { targetLocation } from './aiChangeLocations';
import { UPLOAD_LABELS } from './aiUploads';
import { UploadPanel, canUpload } from './UploadCard';

export default function PointCard({ point, pageType, onShow, onFix, onOpen }) {
  const [isUploading, setIsUploading] = useState(false);
  const uploaderId = useId();
  // A point with an upload carries no fix: the uploader takes the place of Fix this.
  const upload = point.upload && canUpload(point.upload, pageType) ? point.upload : null;

  return (
    <li className="flex flex-col gap-2.5 rounded-[10px] border bg-background p-3">
      <div className="flex gap-2.5">
        <span
          aria-hidden="true"
          className="flex size-5.5 shrink-0 items-center justify-center rounded-full bg-primary text-xs font-semibold text-primary-foreground"
        >
          {point.n}
        </span>
        <div className="min-w-0 flex-1">
          <div className="break-words text-[13px] font-semibold leading-[19px]">{point.title}</div>
          <p className="mt-0.5 whitespace-pre-wrap break-words text-[13px] leading-[19px] text-muted-foreground">
            {point.detail}
          </p>
          <div className="mt-2 flex flex-wrap items-center justify-between gap-2">
            <span className="text-xs leading-4 text-muted-foreground">
              {targetLocation(point.target, pageType).label}
            </span>
            <div className="flex flex-wrap gap-1">
              {onShow && (
                <Button
                  variant="outline"
                  size="sm"
                  aria-label={`Show ${point.title}`}
                  onClick={() => onShow(point)}
                >
                  Show
                </Button>
              )}
              {upload ? (
                <Button
                  variant="ghost"
                  size="sm"
                  className="h-auto min-h-7 max-w-full whitespace-normal text-left text-foreground"
                  aria-expanded={isUploading}
                  aria-controls={isUploading ? uploaderId : undefined}
                  onClick={() => setIsUploading(open => !open)}
                >
                  {UPLOAD_LABELS[upload]}
                </Button>
              ) : (
                point.fix && (
                  <Button
                    variant="ghost"
                    size="sm"
                    className="text-foreground"
                    aria-label={`Fix ${point.title}`}
                    onClick={() => onFix(point)}
                  >
                    Fix this
                  </Button>
                )
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Under the whole card rather than the text column: a narrow chat has little room for it. */}
      {upload && isUploading && (
        <div id={uploaderId} className="border-t pt-2.5">
          <UploadPanel kind={upload} pageType={pageType} onOpen={onOpen} />
        </div>
      )}
    </li>
  );
}
